import React, { FC } from 'react';

import { UnstyledButton, IconStyled } from './styles';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  icon: IconDefinition;
  color?: string;
  size?: string;
}

const Button: FC<ButtonProps> = (props) => {
  return (
    <UnstyledButton {...props}>
      <IconStyled color={props.color} fontSize={props.size} icon={props.icon} />
    </UnstyledButton>
  );
};

export default Button;
